import { Component, JSXElement, Show } from 'solid-js';
import CustomTooltip from '../CustomTooltip/CustomTooltip';
import AuthImage from '../AuthImage/AuthImage';
import CustomCheckbox from '../CustomCheckbox/CustomCheckbox';

export interface CheckBoxListProps {
  index: number;
  listName: string;
  isChecked: boolean;
  thumbnail?: string;
  hideCheckBox?: boolean;
  onSelect?(
    index: number,
    action: 'single_selection' | 'multi_selection'
  ): void;
  'data-cy'?: string;
}

const CheckBoxList: Component<CheckBoxListProps> = (props): JSXElement => {
  return (
    <li class={`list-item group selectable ${props.isChecked ? 'active' : ''}`}>
      <div class="checkradio-group mb-0">
        <div class="input-group checkradio">
          <div
            class="group-items px-1 text-ellipsis"
            onClick={(e) => {
              e.stopPropagation();
              props.onSelect?.(props.index, 'single_selection');
            }}
          >
            <Show when={!props.hideCheckBox}>
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  props.onSelect?.(props.index, 'multi_selection');
                }}
              >
                <CustomCheckbox
                  name="itemCheckbox"
                  value={`select-item-${props.index}`}
                  checked={props.isChecked}
                />
              </div>
            </Show>
            <div class="row-center text-ellipsis pl-1">
              <Show when={!!props.thumbnail}>
                <div class="px-1 flex-0">
                  <AuthImage class="i16" src={props.thumbnail!} />
                </div>
              </Show>
              <CustomTooltip text={props.listName}>
                <div class="text-ellipsis">{props.listName}</div>
              </CustomTooltip>
            </div>
          </div>
        </div>
      </div>
    </li>
  );
};

export default CheckBoxList;
